import { setListener, withEl } from "@front/utils";

const submit = document.querySelector('.js-payment-submit') as HTMLElement;
const alertConfidential = document.querySelector('.js-alert-payment-confidential') as HTMLElement;
const confidential = document.querySelector('.js-payment-confidential-input') as HTMLInputElement;

if(submit) {
    withEl('.js-payment-input', (el: HTMLInputElement) => {
        setListener(el, 'change', () => {
            el.checked && !confidential.checked ? alertConfidential.classList.remove('hidden') : alertConfidential.classList.add('hidden');
            el.checked ? submit.classList.remove('disabled:btn-ui-gray') : submit.classList.add('disabled:btn-ui-gray');
        });
    });

    setListener(submit, 'click', () => {
        confidential.checked ? alertConfidential.classList.add('hidden') : alertConfidential.classList.remove('hidden');
    });

    setListener(confidential, 'change', () => {
        confidential.checked ? alertConfidential.classList.add('hidden') : alertConfidential.classList.remove('hidden');
    });
}